"use strict";

(function (angular) {
    "use strict";
    angular.module('webutils').directive('ngRightClick', function () {
        return function (scope, element, attrs) {
			element.bind("contextmenu", function (event) {
				scope.$apply(function () {
					scope.$eval(attrs.ngRightClick, { 'event': event, '$value': element.val() });
				});
                event.preventDefault();
            });
        };
    });
})(angular);
